import {connect} from 'react-redux';
import InspectionFormPage from './InspectionFormPage';
import {getShumaStepStatus} from '../../actions/steps/getShumaStepStatus';
import {getStepData} from '../../actions/steps/getStepData';
import {getShumaProperties} from '../../actions/steps/getShumaProperties';
import {clearInspectionData} from '../../actions/clearInspectionData';
import {showGlobalErrorMessage} from '../../../../common/actions/globalErrorMessage/showGlobalErrorMessage';

const mapStateToProps = ({
                           stepStatus: {stepStatus},
                           shumaProperties: {shumaTypeID, propertyTypeID, firmShumaID},
                           stepData: {stepData, loading: stepDataLoading, error: stepDataError}
                         }) => ({
  stepStatus,
  stepData,
  stepDataLoading,
  shumaTypeID,
  propertyTypeID,
  firmShumaID,
  stepDataError
});

export default connect(
  mapStateToProps,
  {
    getShumaStepStatus,
    getStepData,
    getShumaProperties,
    clearInspectionData,
    showGlobalErrorMessage
  }
)(InspectionFormPage);
